import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 16,
    },
    label: {
      marginRight: 4,
      fontSize: 12,
    },
    select: {
      width: 60,
      height: 30,
    },
    selectItem: {
      fontSize: 12,
    },
    checkbox: {
      width: 14,
      height: 14,
      fontSize: 12,
    },
  });
